import Emitter from "es6-event-emitter";

class EventBus extends Emitter {
  constructor() {
    super();
  }

  trigger(...args) {
    if (process.env.NODE_ENV !== "production") {
      console.info(...args); // eslint-disable-line
    }

    super.trigger(...args);
  }
}

const eventBus = new EventBus();
export default eventBus;



// WEBPACK FOOTER //
// ./src/common/utilities/eventBus.js